import React, { useState, useEffect } from 'react';
import { Document, Packer, Header, Paragraph, TextRun, HeightRule, convertInchesToTwip, PageNumber,SimpleField,NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import './Operational.css';
import { API_URL } from "./API";



function OperationalChecksForm({ savedGeneralData, project, goBack, contactTestData }) {
  const [formData, setFormData] = useState({
    mechanical: {
      close: '',
      open: ''
    },
    local: {
      closeTest: '',
      openTest: ''
    },
    remote: {
      closeService: '',
      closeTestService: '',
      tripping: ''
    },
    indication: {
      cbOn: '',
      cbOff: '',
      cbTrip: '',
      breakerTest: '',
      breakerService: '',
      springCharged: '',
      tripCkt1: '',
      tripCkt2: ''
    }
  });
 
  const [circuitBreakerData, setCircuitBreakerData] = useState({});
  const [testData, setTestData] = useState({});
  const [contactData, setContactData] = useState({}); 
  const [operationalChecksData, setOperationalChecksData] = useState({}); 
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); 
  const [projectDetails, setProjectDetails] = useState({
    subProjectName: '',
    categoryName: '',
    subcategoryName: '',
    equipmentName: '',
    projectId: '',
    location: ''
  });

  const [reportsList, setReportsList] = useState([]);
  
  const [showReportsList, setShowReportsList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  
  

  useEffect(() => {
    const savedCBData = localStorage.getItem('circuitBreakerFormData');
    if (savedCBData) {
      setCircuitBreakerData(JSON.parse(savedCBData));
    }
        
    const savedTestData = localStorage.getItem('testFormData');
    if (savedTestData) {
      setTestData(JSON.parse(savedTestData));
    }
         
    const savedContactData = localStorage.getItem('timeIntervalData');
    if (savedContactData) {
      setContactData(JSON.parse(savedContactData));
    }
          
    const savedOpChecks = localStorage.getItem('operationalChecksData');
    if (savedOpChecks) {
      setFormData(JSON.parse(savedOpChecks));
    }

    if (savedGeneralData?.circuitBreakerData) {
      setCircuitBreakerData(savedGeneralData.circuitBreakerData);
    }

    if (savedGeneralData?.operationalChecks) {
      setOperationalChecksData(savedGeneralData.operationalChecks);
    }
      
    if (savedGeneralData?.testData) {
      setTestData(savedGeneralData.testData);
    }
    
    if (contactTestData) {
      setContactData(contactTestData);
    }
            
    try {
      const localNavbarData = localStorage.getItem('navbarData'); 
      const localProjectData = localStorage.getItem('createReportData');
      
      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }
    
      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        setProjectDetails({
          subProjectName: parsedProjectData.sub_project_name || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        });
      }
    } catch (error) {
      console.error("Error loading data from localStorage:", error);
      setErrorMessage("Failed to load saved data");
    }
         
    if (savedGeneralData && savedGeneralData.projectData) {
      setProjectDetails(prev => ({
        ...prev,
        subProjectName: savedGeneralData.projectData.sub_project_name || "",
        categoryName: savedGeneralData.projectData.category_name || "",
        subcategoryName: savedGeneralData.projectData.subcategory_name || "",
        equipmentName: savedGeneralData.projectData.equipment_name || "",
        projectId: savedGeneralData.projectData.project_id || "",
        location: savedGeneralData.projectData.location || prev.location || ""
      }));
    }
  }, [savedGeneralData, contactTestData]);

  const handleGetReports = async () => {
    try {
      setIsLoading(true);
      setErrorMessage("");
      
      console.log("Fetching test reports...");
      
      const response = await fetch(`${API_URL}/test_report/get_test_reports`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'same-origin',
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
      }
      
      const result = await response.json();
      console.log('GET API Response:', result);
      
      const reports = Array.isArray(result) ? result : (result.reports || result.data || []);
      setReportsList(reports);
      setShowReportsList(true);
      
      alert(`Successfully fetched ${reports.length} test reports!`);
      
    } catch (error) {
      console.error("Error fetching reports:", error);
      
      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running.");
        alert("Cannot connect to server. Please check if the backend is running.");
      } else {
        setErrorMessage(`Error fetching reports: ${error.message}`);
        alert(`Error fetching reports: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const loadAllFormDataFromStorage = () => {
    try {
      const savedCBData = JSON.parse(localStorage.getItem('circuitBreakerFormData') || '{}');
      const savedTestData = JSON.parse(localStorage.getItem('testFormData') || '{}');
      const savedContactData = JSON.parse(localStorage.getItem('timeIntervalData') || '{}');
      const savedOpChecksData = JSON.parse(localStorage.getItem('operationalChecksData') || '{}');
      const savedProjectData = JSON.parse(localStorage.getItem('createReportData') || '{}');
      const savedNavbarData = JSON.parse(localStorage.getItem('navbarData') || '{}');
      
      return {
        circuitBreakerData: { ...circuitBreakerData, ...savedCBData },
        testData: { ...testData, ...savedTestData },
        contactData: { ...contactData, ...savedContactData },
        operationalChecksData: { ...formData, ...savedOpChecksData },
        projectDetails: {
          subProjectName: savedProjectData.sub_project_name || projectDetails.subProjectName || "",
          categoryName: savedProjectData.category_name || projectDetails.categoryName || "",
          subcategoryName: savedProjectData.subcategory_name || projectDetails.subcategoryName || "",
          equipmentName: savedProjectData.equipment_name || projectDetails.equipmentName || "",
          projectId: savedProjectData.project_id || projectDetails.projectId || "",
          location: savedProjectData.location || savedNavbarData.location || projectDetails.location || ""
        }
      };
    } catch (error) {
      console.error("Error loading form data from storage:", error);
      return {
        circuitBreakerData,
        testData,
        contactData,
        operationalChecksData: formData,
        projectDetails
      };
    }
  };

const clearAllStorageData = () => {
  try {
    const keysToRemove = [
      'circuitBreakerFormData',      
      'testFormData',               
      'timeIntervalData',            
      'operationalChecksData',        
      'operationalInspection',
      'circuitBreakerInspectionPDF',
      'circuitBreakerInspectionWord',
      'createReportData'
    ];
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    
    localStorage.setItem('clearCircuitBreakerForm', 'true');
    localStorage.setItem('clearTestForm', 'true');
    
    
  } catch (error) {
    console.error("Error clearing storage data:", error);
  }
};

const resetAllFormStates = () => {
  try {

    setFormData({
      mechanical: {
        close: '',
        open: ''
      },
      local: {
        closeTest: '',
        openTest: ''
      },
      remote: {
        closeService: '',
        closeTestService: '',
        tripping: ''
      },
      indication: {
        cbOn: '',
        cbOff: '',
        cbTrip: '',
        breakerTest: '',
        breakerService: '',
        springCharged: '',
        tripCkt1: '',
        tripCkt2: ''
      }
    });


    setCircuitBreakerData({});
    setTestData({});
    setContactData({}); 
    setOperationalChecksData({});
    
    setProjectDetails({
      subProjectName: '',
      categoryName: '',
      subcategoryName: '',
      equipmentName: '',
      projectId: '',
      location: ''
    });

    setFormSubmitted(false);
    setErrorMessage('');
    setIsUpdating(false);
    setShowReportsList(false);
    
    console.log("All form states reset successfully");
  } catch (error) {
    console.error("Error resetting form states:", error);
  }
};

  const handleChange = (section, field, value) => {
    const updatedData = {
      ...formData,
      [section]: {
        ...formData[section],
        [field]: value
      }
    };
    
    setFormData(updatedData);
    localStorage.setItem('operationalChecksData', JSON.stringify(updatedData));
  };
  
const generateWordBlob = () => {
  return new Promise((resolve, reject) => {
    try {
     
        const storedFormData = JSON.parse(localStorage.getItem('circuitBreakerFormData') || '{}');
        const testFormData = JSON.parse(localStorage.getItem('testFormData') || '{}');
        const coilIntervalData = JSON.parse(localStorage.getItem('timeIntervalData') || '{}');

     
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

     
      function findValue(data, searchTerms, defaultValue = "N/A") {
        if (!data || typeof data !== 'object') return defaultValue;
        
        const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];
        
        for (let term of terms) {
          if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
            return data[term];
          }
        }
        
        const dataKeys = Object.keys(data);
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        return defaultValue;
      }

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

     
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
              console.warn("Could not convert image to base64:", error);
              resolve(null);
            }
          };
          img.onerror = function() {
            console.warn("Could not load image from URL:", url);
            resolve(null);
          };
          img.src = url;
        });
      };
      
     
     
      const createLightWatermark = (base64Data) => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
              
              ctx.globalAlpha = 0.15; 
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
            console.warn("Could not create light watermark:", error);
            resolve(null);
          }
        });
      };

      
      const documentSections = [];

      
const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
     
   const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 
      
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
       
        createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {
       
        const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                             font: "Times New Roman",
                              color:"#1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 80, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ]
            })
          );
        } else {
        
          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color:"#1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                  font: "Courier New",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "Courier New",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }

        headerElements.push(new Paragraph({ text: "" })); 
        documentSections.push(...headerElements);

        
      

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Description", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "CIRCUIT BREAKER INSPECTION/ TEST REPORT", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Date", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.date), font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Project", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Report No", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Customer", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " "  , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  
                ]
              }),
              new TableRow({
                children: [
                  
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   "Client", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   (storedFormData?.client), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " "  , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                   
                  
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 



              
        
             documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "LOCATION:",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      }),
                      new TextRun({
                        text: storedFormData.location || '',
                        font: "Courier New",
                        size: 24
                      })
                    ]
                  })
                );
              
                documentSections.push(new Paragraph({ text: "" }));
              

        
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "NAME PLATE DETAILS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const nameplateFields = [
         
          { label: "Make", value: storedFormData?.make },
          { label: "Rated Frequency", value: storedFormData?.ratedFrequency },
          { label: "Serial Number", value: storedFormData?.serialNumber },
          { label: "Insulation Level", value: storedFormData?.insulationLevel },
          { label: "Production Year", value: storedFormData?.productionYear },
          { label: "Closing Coil Supply Volts", value: storedFormData?.closingCoilSupplyVolts },
          { label: "Rated Voltage", value: storedFormData?.ratedVoltage },
          { label: "Opening Coil Supply Volts", value: storedFormData?.openingCoilSupplyVolts },
          { label: "Rated Current", value: storedFormData?.ratedCurrent },
          { label: "Motor Supply Volts", value: storedFormData?.motorSupplyVolts }
        ];

        const nameplateRows = [
         
        ];

        nameplateFields.forEach(field => {
          nameplateRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  field.label, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE },
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   safeToString(field.value), font: "Courier New" })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE }
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: nameplateRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 


        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Insulation Resistance Test - Breaker Position: CLOSE",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const closePositionRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 30, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied DC Voltage (V)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Resistance", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (testFormData?.closePositionData && testFormData.closePositionData.length > 0) {
          testFormData.closePositionData.forEach(item => {
            closePositionRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.reference), font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.appliedVoltage), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(item.resistanceValue)} ${safeToString(item.resistanceUnit || 'MΩ')}`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          closePositionRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 3
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: closePositionRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));

        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Insulation Resistance Test - Breaker Position: OPEN",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const openPositionRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                
                width: { size: 30, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied DC Voltage (V)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Resistance", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (testFormData?.openPositionData && testFormData.openPositionData.length > 0) {
          testFormData.openPositionData.forEach(item => {
            openPositionRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.reference), font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.appliedVoltage), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(item.resistanceValue)} ${safeToString(item.resistanceUnit || 'MΩ')}`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          openPositionRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 3
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: openPositionRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Illumination/Heating Circuit Check",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const illuminationRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (testFormData?.illuminationData && testFormData.illuminationData.length > 0) {
          testFormData.illuminationData.forEach(item => {
            illuminationRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.description), font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.status), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          illuminationRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 2
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: illuminationRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Contact Resistance Test",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        
        const contactResistanceRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Resistance", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (coilIntervalData?.contactResistance && Object.keys(coilIntervalData.contactResistance).length > 0) {
          Object.entries(coilIntervalData.contactResistance).forEach(([phase, value]) => {
            let cleanValue = value;
            if (typeof value === 'string') {
              cleanValue = value.replace(/[¼½¾©®™]/g, '').trim();
            }
            contactResistanceRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${phase}-Phase Resistance`, font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(cleanValue)} μΩ`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          contactResistanceRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No contact resistance data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 2
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: contactResistanceRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Coil Resistance Check",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);

function formatResistanceValue(resistanceData) {
  if (typeof resistanceData === 'object' && resistanceData !== null) {
    const value = resistanceData.value || resistanceData.resistance || '';
    const unit = resistanceData.unit || 'Ω';
    return `${safeToString(value)} ${unit}`;
  } else {
    
    return `${safeToString(resistanceData)} Ω`;
  }
}


const coilResistanceRows = [
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Coil Type", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
          fill: "a6a6a6" 
        },
        width: { size: 50, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Resistance", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
          fill: "a6a6a6" 
        },
        width: { size: 50, type: WidthType.PERCENTAGE }
      })
    ]
  })
];

if (coilIntervalData?.coilResistance) {
 
  if (coilIntervalData.coilResistance.closing) {
    coilResistanceRows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Closing Coil", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(coilIntervalData.coilResistance.closing), font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    );
  }
  

  if (coilIntervalData.coilResistance.tripping) {
    if (typeof coilIntervalData.coilResistance.tripping === 'object' && !Array.isArray(coilIntervalData.coilResistance.tripping)) {
     
      Object.entries(coilIntervalData.coilResistance.tripping).forEach(([index, trippingData]) => {
        coilResistanceRows.push(
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `Tripping Coil-${parseInt(index) + 1}`, font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
                  fill: "a6a6a6" 
                }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(trippingData), font: "Courier New" })] })],
                borders: tableBorders
              })
            ]
          })
        );
      });
    } else {
      
      coilResistanceRows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Tripping Coil", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
                fill: "a6a6a6" 
              }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(coilIntervalData.coilResistance.tripping), font: "Courier New" })] })],
              borders: tableBorders
            })
          ]
        })
      );
    }
  }
  
 
  if (coilIntervalData.coilResistance.spring) {
    coilResistanceRows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Spring Charge Motor", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(coilIntervalData.coilResistance.spring), font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    );
  }
} else {
  coilResistanceRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "No coil resistance data available", font: "Courier New" })] })],
          borders: tableBorders,
          columnSpan: 2
        })
      ]
    })
  );
}

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: coilResistanceRows
  })
);

documentSections.push(new Paragraph({ text: "" })); 



documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Timing Interval Test",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


const timingRows = [
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 31, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R (mSec)", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 23, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y (mSec)", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 23, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B (mSec)", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 23, type: WidthType.PERCENTAGE }
      })
    ]
  })
];

if (coilIntervalData && coilIntervalData.timingValues) {
  const timingGroups = {};
  
  Object.keys(coilIntervalData.timingValues).forEach(key => {
    const parts = key.split('-');
    if (parts.length >= 1) {
      const phase = parts[parts.length - 1];
      const reference = parts.slice(0, -1).join('-');
      
      if (!timingGroups[reference]) {
        timingGroups[reference] = {};
      }
      timingGroups[reference][phase] = coilIntervalData.timingValues[key];
    }
  });
  
  const cleanReferenceName = (reference) => {
    if (reference === 'Close') {
      return 'Close';
    } else if (reference.startsWith('Open-')) {
      const number = reference.split('-')[1];
      if (number === '0') {
        return 'Open TC-1';
      } else {
        return `Open TC-${parseInt(number) + 1}`;
      }
    } else if (reference.startsWith('Open TC')) {
      return reference;
    } else if (reference.startsWith('Close-Open-')) {
      const number = reference.split('-')[2];
      if (number === '0') {
        return 'Close-Open TC-1';
      } else {
        return `Close-Open TC-${parseInt(number) + 1}`;
      }
    } else if (reference.startsWith('Close-Open TC')) {
      return reference;
    }
    return reference;
  };
  
  const referenceOrder = ['Close', 'Open-0', 'Open-1', 'Open-2', 'Open-3', 'Open-4',
                         'Open TC-1', 'Open TC-2', 'Open TC-3', 'Open TC-4',
                         'Close-Open-0', 'Close-Open-1', 'Close-Open-2', 'Close-Open-3', 'Close-Open-4',
                         'Close-Open TC-1', 'Close-Open TC-2', 'Close-Open TC-3', 'Close-Open TC-4'];
  
  referenceOrder.forEach(reference => {
    if (timingGroups[reference]) {
      const group = timingGroups[reference];
      const rValue = group['R'] || group['r'] || 'N/A';
      const yValue = group['Y'] || group['y'] || 'N/A';
      const bValue = group['B'] || group['b'] || 'N/A';
      
      const displayName = cleanReferenceName(reference);
      timingRows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: displayName, font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(yValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(bValue), font: "Courier New" })] })],
              borders: tableBorders
            })
          ]
        })
      );
    }
  });
  
 
  Object.keys(timingGroups).forEach(reference => {
    if (!referenceOrder.includes(reference)) {
      const group = timingGroups[reference];
      const rValue = group['R'] || group['r'] || 'N/A';
      const yValue = group['Y'] || group['y'] || 'N/A';
      const bValue = group['B'] || group['b'] || 'N/A';
      
      const displayName = cleanReferenceName(reference);
      timingRows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: displayName, font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(yValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(bValue), font: "Courier New" })] })],
              borders: tableBorders
            })
          ]
        })
      );
    }
  });
} else {
  timingRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ children: [new TextRun({ text: "No timing interval test data available", font: "Courier New" })] })],
          borders: tableBorders,
          columnSpan: 4
        })
      ]
    })
  );
}

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: timingRows
  })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Mechanical Operation",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operation Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Mechanical Close", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.mechanical?.close === 'yes' ? 'Ok' : (formData?.mechanical?.close === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Mechanical Open", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.mechanical?.open === 'yes' ? 'Ok' : (formData?.mechanical?.open === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Local Operation from TNC Switch",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operation Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Local Close (Test & Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.local?.closeTest === 'yes' ? 'Ok' : (formData?.local?.closeTest === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Local Open (Test & Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.local?.openTest === 'yes' ? 'Ok' : (formData?.local?.openTest === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Remote Operation",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operation Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remote Close (Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.remote?.closeService === 'yes' ? 'Ok' : (formData?.remote?.closeService === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remote Close (Test & Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.remote?.closeTestService === 'yes' ? 'Ok' : (formData?.remote?.closeTestService === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remote Tripping from Relay", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.remote?.tripping === 'yes' ? 'Ok' : (formData?.remote?.tripping === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Indication Checks",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Indication Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CB ON Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.cbOn === 'yes' ? 'Ok' : (formData?.indication?.cbOn === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CB OFF Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.cbOff === 'yes' ? 'Ok' : (formData?.indication?.cbOff === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CB TRIP Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.cbTrip === 'yes' ? 'Ok' : (formData?.indication?.cbTrip === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "BREAKER IN TEST Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.breakerTest === 'yes' ? 'Ok' : (formData?.indication?.breakerTest === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "BREAKER IN SERVICE Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.breakerService === 'yes' ? 'Ok' : (formData?.indication?.breakerService === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "SPRING CHARGED Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.springCharged === 'yes' ? 'Ok' : (formData?.indication?.springCharged === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TRIP CKT HEALTHY -1 Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.tripCkt1 === 'yes' ? 'Ok' : (formData?.indication?.tripCkt1 === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TRIP CKT HEALTHY -2 Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.tripCkt2 === 'yes' ? 'Ok' : (formData?.indication?.tripCkt2 === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);



documentSections.push(new Paragraph({ text: "" })); 

    const convertInchesToTwip = (inches) => {
           return Math.round(inches * 1440);
         };
 
 const footerTable = new Table({
  width: { size: 100, type: WidthType.PERCENTAGE, },
  alignment: AlignmentType.LEFT,
  rows: [
    new TableRow({
      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
      children: [
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "Pie Power",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                }),
                new SimpleField({
                  instruction: "PAGE",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                }),
                new SimpleField({
                  instruction: "NUMPAGES",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        })
      ]
    })
  ]
});
        const pageBorders = {
  pageBorderTop: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },


  pageBorderRight: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderBottom: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderLeft: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  }
};

      const doc = new Document({
  sections: [
    {
      properties: {
        page: {
          margin: {
            top: convertInchesToTwip(0.5),
            right: convertInchesToTwip(0.5),
            bottom: convertInchesToTwip(1.0),
            left: convertInchesToTwip(0.5)
          },
          borders: pageBorders,
          pageNumbers: {
            start: 1,
            formatType: NumberFormat.DECIMAL
          }
        }
      },
      footers: {
        default: new Footer({
          children: [
            footerTable,
            new Paragraph({
              children: [
                new TextRun({
                  text: "Page ",
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                  children: [PageNumber.CURRENT],
                  font: "Courier New",
                  size: 16
                }),

                new TextRun({
                  text: " of ",
                  font: "Courier New",
                  size: 16
                  }),
               
                new TextRun({
                  children: [PageNumber.TOTAL_PAGES],
                  font: "Courier New",
                  size: 16
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: {
                before: 200
              }
            })
          ]
        })
      },
      headers: lightWatermarkBase64 ? {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          ]
        })
      } : undefined,
      children: documentSections
    }
  ]
});

               Packer.toBlob(doc).then(blob => {
                 resolve(blob);
               }).catch(error => {
                 console.error("Error generating Word blob:", error);
                 reject(error);
               });
               });
       
             }).catch(error => {
               console.error("Error fetching logo:", error);
               reject(error);
             });
       
           } catch (error) {
             console.error("Error generating Word blob:", error);
             reject(error);
           }
         });
       };



  const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};


const handleDownloadPdf = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const allFormData = loadAllFormDataFromStorage();
    const safeFormData = allFormData && typeof allFormData === 'object' ? allFormData : {
      circuitBreakerData,
      testData,
      contactData,
      operationalChecksData: formData,
      projectDetails
    };
    
    const wordBlob = await generateWordBlob(safeFormData);
    
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${(today.getMonth()+1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    const filename = `CircuitBreaker_Report_${circuitBreakerData.reportNo || formattedDate}.docx`;
    
    saveAs(wordBlob, filename);
    

    clearAllStorageData();
    

    resetAllFormStates();
    

    setTimeout(() => {
      alert("Report downloaded successfully! All form data has been cleared.");
    }, 100);
    
  } catch (error) {
    console.error("Error generating Word document:", error);
    setErrorMessage(`Error generating Word document: ${error.message}`);
    alert(`Error generating Word document: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};


const handleSave = async (e) => {
  e.preventDefault();
  setFormSubmitted(true);
  setIsLoading(true);
  setErrorMessage("");
 
  try {
    const allFormData = loadAllFormDataFromStorage();
    const safeFormData = formData && typeof formData === 'object' ? {
      circuitBreakerData: formData.circuitBreakerData || allFormData.circuitBreakerData,
      testData: formData.testData || allFormData.testData,
      contactData: formData.contactData || allFormData.contactData,
      operationalChecksData: formData.operationalChecksData || allFormData.operationalChecksData
    } : allFormData;
 
    console.log("Safe form data:", safeFormData);
 
    const convertArrayToDict = (data) => {
      const convertedData = {};
     
      for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
          convertedData[key] = {};
          value.forEach((item, index) => {
            if (typeof item === 'object' && item !== null) {
              for (const [subKey, subValue] of Object.entries(item)) {
                if (!convertedData[key][subKey]) {
                  convertedData[key][subKey] = {};
                }
                convertedData[key][subKey][`reading_${index + 1}`] = subValue;
              }
            } else {
              convertedData[key][`reading_${index + 1}`] = item;
            }
          });
        } else if (typeof value === 'object' && value !== null) {
          convertedData[key] = convertArrayToDict(value);
        } else {
          convertedData[key] = value;
        }
      }
     
      return convertedData;
    };
 
    const convertedFormData = {
      circuitBreakerData: convertArrayToDict(safeFormData.circuitBreakerData || {}),
      testData: convertArrayToDict(safeFormData.testData || {}),
      contactData: convertArrayToDict(safeFormData.contactData || {}),
      operationalChecksData: convertArrayToDict(safeFormData.operationalChecksData || {})
    };
 
    console.log("Original form data:", safeFormData);
    console.log("Converted form data:", convertedFormData);
   
    const wordBlob = await generateWordBlob(convertedFormData);
   
    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);
   
    reader.onloadend = async () => {
      try {
        const base64data = reader.result;
        localStorage.setItem('circuitBreakerInspectionWord', base64data);
       
        const currentDate = new Date().toISOString().split('T')[0];
        const formLocation = convertedFormData.circuitBreakerData?.location || "";
       
     
        const getProjectId = () => {
          console.log("=== Starting project_id extraction ===");
         
         
          if (project?.project_id) {
            const id = parseInt(project.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from project prop:", id);
              return id;
            }
          }
         
         
          if (projectDetails?.projectId) {
            const id = parseInt(projectDetails.projectId);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from projectDetails:", id);
              return id;
            }
          }
     
          try {
            const createReportData = localStorage.getItem('createReportData');
            if (createReportData) {
              const parsedData = JSON.parse(createReportData);
              if (parsedData.project_id) {
                const id = parseInt(parsedData.project_id);
                if (!isNaN(id) && id > 0) {
                  console.log("✓ Using project_id from createReportData:", id);
                  return id;
                }
              }
            }
          } catch (error) {
            console.error("Error parsing createReportData:", error);
          }
         
         
          if (convertedFormData.circuitBreakerData?.project_id) {
            const id = parseInt(convertedFormData.circuitBreakerData.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from form data:", id);
              return id;
            }
          }
         
         
          if (convertedFormData.circuitBreakerData?.reportNo) {
            const id = parseInt(String(convertedFormData.circuitBreakerData.reportNo).replace(/\D/g, ''));
            if (!isNaN(id) && id > 0) {
              console.log("⚠ Using project_id from reportNo:", id);
              return id;
            }
          }
         
          console.error(" Could not find valid project_id!");
          alert("Warning: Could not determine project ID. Report may be saved incorrectly.");
          return 1;
        };
       
        const projectId = getProjectId();
        console.log("=== Final project_id selected:", projectId, "===");
       
        const apiRequestData = {
          equipment_name: String(projectDetails.equipmentName || convertedFormData.circuitBreakerData?.description || "Circuit Breaker"),
          test_date: String(convertedFormData.circuitBreakerData?.date || currentDate),
          category_name: String(projectDetails.categoryName || "Circuit Breaker"),
          subcategory_name: String(projectDetails.subcategoryName || "Operational Check"),
          sub_project_name: String(projectDetails.subProjectName || convertedFormData.circuitBreakerData?.project || "Project"),
          project_id: projectId,
          location: String(formLocation || projectDetails.location || ""),
          report_file: {  
            report_word: base64data,
            filename: `CircuitBreaker_Test_Report_${Date.now()}.docx`,
            file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          },
          test_data: {
            circuitBreakerData: convertedFormData.circuitBreakerData || {},
            testData: convertedFormData.testData || {},
            contactData: convertedFormData.contactData || {},
            operationalChecksData: convertedFormData.operationalChecksData || {}
          }
        };
   
        console.log("=== Final API Request Data ===");
        console.log("Project ID type:", typeof apiRequestData.project_id);
        console.log("Project ID value:", apiRequestData.project_id);
        console.log("Final test_data structure:", JSON.stringify(apiRequestData.test_data, null, 2));
   
        const response = await fetch(`${API_URL}/test_report/create_test_report`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(apiRequestData),
          mode: 'cors',
          credentials: 'same-origin',
        });
   
        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
            console.error("Detailed API Error:", errorData);
          } catch (jsonError) {
            console.error("Could not parse error response as JSON:", jsonError);
            errorData = { message: response.statusText };
          }
         
          throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
        }
   
        const result = await response.json();
console.log('API Response:', result);



alert("Data submitted successfully");
       
      } catch (error) {
        console.error("Error in Word document processing or API call:", error);
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
   
  } catch (error) {
    console.error("Error saving data:", error);
   
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server. Please check if the backend is running.");
      alert("Cannot connect to server. Please check if the backend is running.");
    } else if (error.message.includes("generateWordBlob is not defined")) {
      setErrorMessage("Word document generation function is missing. Please check your imports.");
      alert("Word document generation function is missing. Please check your imports.");
    } else {
      setErrorMessage(`Error: ${error.message}`);
      alert(`Error saving data: ${error.message}`);
    }
    setIsLoading(false);
  }
};
 

return (
<div className="form-container450">
<span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
         {errorMessage && (
        <div className="error-message" style={{ color: 'red', margin: '10px 0', padding: '8px', backgroundColor: '#ffeeee', borderRadius: '4px' }}>
{errorMessage}
</div>
)}

<div className="form-grid">
<div className="form-column">
<h2 className="section-title">OPERATIONAL CHECKS</h2>

<div className="card main-card_cb">
<h3 className="card-header_cb">a) MECHANICAL OPERATION</h3>
<div className="card-body_cb">
  <div className="cb-form-item">
    <label>CLOSE</label>
    <select 
      onChange={(e) => handleChange('mechanical', 'close', e.target.value)}
      value={formData.mechanical?.close || ''}
      disabled={isLoading}
    >
      <option value="">Select</option>
      <option value="yes">Ok</option>
      <option value="no">Not Ok</option>
    </select>
  </div>
          
<div className="cb-form-item">
<label>OPEN</label>
<select 
onChange={(e) => handleChange('mechanical', 'open', e.target.value)}
value={formData.mechanical?.open || ''}
disabled={isLoading}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>
</div>
</div>



<div className="card main-card_cb">
<h3 className="card-header_cb">b) LOCAL OPERATION FROM TNC SWITCH</h3>
<div className="card-body_cb">
<div className="cb-form-item">
<label>CLOSE(TEST & SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('local', 'closeTest', e.target.value)}
value={formData.local?.closeTest || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>OPEN(TEST & SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('local', 'openTest', e.target.value)}
value={formData.local?.openTest || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>
</div>
</div>

<div className="card main-card_cb">
<h3 className="card-header_cb">c) REMOTE OPERATION</h3>
<div className="card-body_cb">
<div className="cb-form-item">
<label>CLOSE(SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('remote', 'closeService', e.target.value)}
value={formData.remote?.closeService || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>CLOSE(TEST & SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('remote', 'closeTestService', e.target.value)}
value={formData.remote?.closeTestService || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>TRIPPING FROM RELAY (PROTECTION CKT) / SPARE TRIPPING CONTACTS</label>
<select 
onChange={(e) => handleChange('remote', 'tripping', e.target.value)}
value={formData.remote?.tripping || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>
</div>
</div>
</div>

<div className="form-column">
<h2 className="section-title">INDICATION CHECK</h2>

<div className="card main-card_cb">
<div className="card-body_cb">
<div className="cb-form-item">
<label>CB ON</label>
<select 
onChange={(e) => handleChange('indication', 'cbOn', e.target.value)}
value={formData.indication?.cbOn || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>CB OFF</label>
<select 
onChange={(e) => handleChange('indication', 'cbOff', e.target.value)}
value={formData.indication?.cbOff || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>CB TRIP</label>
<select 
onChange={(e) => handleChange('indication', 'cbTrip', e.target.value)}
value={formData.indication?.cbTrip || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>BREAKER IN TEST</label>
<select 
onChange={(e) => handleChange('indication', 'breakerTest', e.target.value)}
value={formData.indication?.breakerTest || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>BREAKER IN SERVICE</label>
<select 
onChange={(e) => handleChange('indication', 'breakerService', e.target.value)}
value={formData.indication?.breakerService || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>SPRING CHARGED</label>
<select 
onChange={(e) => handleChange('indication', 'springCharged', e.target.value)}
value={formData.indication?.springCharged || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>TRIP CKT HEALTHY -1</label>
<select 
onChange={(e) => handleChange('indication', 'tripCkt1', e.target.value)}
value={formData.indication?.tripCkt1 || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="cb-form-item">
<label>TRIP CKT HEALTHY -2</label>
<select 
onChange={(e) => handleChange('indication', 'tripCkt2', e.target.value)}
value={formData.indication?.tripCkt2 || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not OK</option>
</select>
</div>
</div>
</div>
</div>
</div>

<div className="navigation">
<button className="nav-button" onClick={goBack}>Back</button>

<button type="button" className="nav-button" onClick={handleSave} disabled={isLoading}>
{isLoading ? "Processing..." : "Submit"}
</button>

{formSubmitted && (
<button 
type="button"
className="nav-button" 
onClick={handleDownloadPdf}
disabled={isLoading}
style={{ 
marginLeft: '10px', 
backgroundColor: '#4CAF50', 
cursor: isLoading ? 'not-allowed' : 'pointer' 
}}
>
Download Word
</button>
)}
</div>
</div>
);
}

export default OperationalChecksForm;
